// apiClient.js - VERSIÓN SIMPLIFICADA Y FUNCIONAL
// Guardar este archivo como: src/apiClient.js

const API_URL = 'https://repaircell-api.davidproaniop.workers.dev';

console.log('🚀 API Client cargado - URL:', API_URL);

class ApiClient {
  // ============ CLIENTES ============

  async getClientes() {
    console.log('📋 GET /api/clientes');
    const response = await fetch(`${API_URL}/api/clientes`);
    const data = await response.json();
    console.log('✅ Clientes obtenidos:', data.length);

    return data.map(c => ({
      id: c.id,
      nombre: c.nombre,
      cedula: c.cedula,
      contacto: c.contacto,
      esFrecuente: Boolean(c.es_frecuente)
    }));
  }

  async createCliente(cliente) {
    console.log('➕ POST /api/clientes:', cliente.nombre);
    const response = await fetch(`${API_URL}/api/clientes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: cliente.id,
        nombre: cliente.nombre,
        cedula: cliente.cedula || '',
        contacto: cliente.contacto || '',
        esFrecuente: cliente.esFrecuente
      })
    });
    const result = await response.json();
    console.log('✅ Cliente creado:', result);
    return result;
  }

  async updateCliente(id, cliente) {
    console.log('✏️ PUT /api/clientes/' + id);
    const response = await fetch(`${API_URL}/api/clientes/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        nombre: cliente.nombre,
        cedula: cliente.cedula || '',
        contacto: cliente.contacto || '',
        esFrecuente: cliente.esFrecuente
      })
    });
    return response.json();
  }

  async deleteCliente(id) {
    console.log('🗑️ DELETE /api/clientes/' + id);
    const response = await fetch(`${API_URL}/api/clientes/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  }

  // ============ EQUIPOS ============

  async getEquipos() {
    console.log('📱 GET /api/equipos');
    const response = await fetch(`${API_URL}/api/equipos`);
    const data = await response.json();
    console.log('✅ Equipos obtenidos:', data.length);

    return data.map(e => ({
      id: e.id,
      clienteId: e.cliente_id,
      clienteNombre: e.cliente_nombre,
      clienteCedula: e.cliente_cedula,
      clienteContacto: e.cliente_contacto,
      foto: e.foto_url,
      detalle: e.detalle,
      estado: e.estado,
      riesgo: Boolean(e.riesgo),
      precioReparacion: String(e.precio_reparacion || ''),
      costoRepuesto: String(e.costo_repuesto || ''),
      tecnico: e.tecnico,
      credito: Boolean(e.credito),
      deudaSaldada: Boolean(e.deuda_saldada),
      fecha: e.fecha,
      hora: e.hora
    }));
  }

  async createEquipo(equipo) {
    console.log('➕ POST /api/equipos:', equipo.clienteNombre);

    // Si tiene foto, subirla primero
    let fotoUrl = null;
    if (equipo.foto && equipo.foto.startsWith('data:')) {
      console.log('📸 Subiendo imagen...');
      fotoUrl = await this.uploadImage(equipo.id, equipo.foto);
    }

    const response = await fetch(`${API_URL}/api/equipos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: equipo.id,
        clienteId: equipo.clienteId,
        clienteNombre: equipo.clienteNombre,
        clienteCedula: equipo.clienteCedula || '',
        clienteContacto: equipo.clienteContacto || '',
        fotoUrl: fotoUrl,
        detalle: equipo.detalle,
        estado: equipo.estado,
        riesgo: equipo.riesgo,
        precioReparacion: parseFloat(equipo.precioReparacion || 0),
        costoRepuesto: parseFloat(equipo.costoRepuesto || 0),
        tecnico: equipo.tecnico,
        credito: equipo.credito,
        deudaSaldada: equipo.deudaSaldada,
        fecha: equipo.fecha,
        hora: equipo.hora
      })
    });
    const result = await response.json();
    console.log('✅ Equipo creado:', result);
    return result;
  }

  async updateEquipo(id, updates) {
    console.log('✏️ PUT /api/equipos/' + id);
    const response = await fetch(`${API_URL}/api/equipos/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        precioReparacion: parseFloat(updates.precioReparacion || 0),
        costoRepuesto: parseFloat(updates.costoRepuesto || 0),
        deudaSaldada: updates.deudaSaldada
      })
    });
    return response.json();
  }

  // ============ DÍAS CERRADOS ============

  async getDiasCerrados() {
    console.log('📅 GET /api/dias-cerrados');
    const response = await fetch(`${API_URL}/api/dias-cerrados`);
    const data = await response.json();
    console.log('✅ Días cerrados obtenidos:', data.length);

    return data.map(dia => ({
      fecha: dia.fecha,
      totalIngresos: dia.total_ingresos,
      totalRepuestos: dia.total_repuestos,
      gananciaTotal: dia.ganancia_total,
      equipos: dia.equipos
    }));
  }

  async createDiaCerrado(dia) {
    console.log('🔒 POST /api/dias-cerrados:', dia.fecha);
    const response = await fetch(`${API_URL}/api/dias-cerrados`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Date.now().toString(),
        fecha: dia.fecha,
        totalIngresos: dia.totalIngresos,
        totalRepuestos: dia.totalRepuestos,
        gananciaTotal: dia.gananciaTotal,
        equipos: dia.equipos
      })
    });
    return response.json();
  }

  // ============ CONFIGURACIÓN ============

  async getDiaActual() {
    console.log('📆 GET /api/config/dia-actual');
    const response = await fetch(`${API_URL}/api/config/dia-actual`);
    const data = await response.json();
    return data.diaActual;
  }

  async updateDiaActual(diaActual) {
    console.log('📆 PUT /api/config/dia-actual');
    const response = await fetch(`${API_URL}/api/config/dia-actual`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ diaActual })
    });
    return response.json();
  }

  // ============ IMÁGENES ============

  async uploadImage(imageId, base64Image) {
    console.log('📸 Subiendo imagen...');
    try {
      const response = await fetch(base64Image);
      const blob = await response.blob();

      const formData = new FormData();
      formData.append('image', blob, `${imageId}.jpg`);
      formData.append('imageId', imageId);

      const uploadResponse = await fetch(`${API_URL}/api/upload-image`, {
        method: 'POST',
        body: formData
      });

      if (!uploadResponse.ok) {
        throw new Error(`Error: ${uploadResponse.status}`);
      }

      const result = await uploadResponse.json();
      const imageUrl = `${API_URL}${result.imageUrl}`;
      console.log('✅ Imagen subida');
      return imageUrl;
    } catch (error) {
      console.error('❌ Error subiendo imagen:', error);
      return null;
    }
  }

  // ============ SINCRONIZACIÓN ============

  async syncAll() {
    console.log('🔄 Sincronizando todos los datos...');

    try {
      const [clientes, equipos, dias, diaActual] = await Promise.all([
        this.getClientes(),
        this.getEquipos(),
        this.getDiasCerrados(),
        this.getDiaActual()
      ]);

      console.log('✅ Sincronización completa:', {
        clientes: clientes.length,
        equipos: equipos.length,
        dias: dias.length
      });

      return {
        clientes,
        equipos,
        dias,
        diaActual,
        success: true
      };
    } catch (error) {
      console.error('❌ Error en sincronización:', error);
      return {
        clientes: [],
        equipos: [],
        dias: [],
        diaActual: new Date().toLocaleDateString('es-EC'),
        success: false,
        error: error.message
      };
    }
  }
}

export const apiClient = new ApiClient();

console.log('✅ apiClient exportado y listo');